import React from 'react';

const GameBlackjack = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.86851 0.851365L19.8304 1.72246C21.3434 1.85483 22.4628 3.18897 22.3304 4.70195L21.1107 18.6492C20.9781 20.162 19.6441 21.2806 18.1312 21.1482L17.8353 21.1219C17.3852 21.7598 16.6693 22.2037 15.8304 22.2771L5.86851 23.1492C4.35569 23.2815 3.02161 22.162 2.88902 20.6492L1.66929 6.70195C1.53712 5.18909 2.6564 3.8558 4.16929 3.72344L6.8773 3.48515L6.88999 3.35137C7.02236 1.83845 8.35562 0.719149 9.86851 0.851365ZM4.30015 5.21758C3.61258 5.27773 3.10354 5.88356 3.16343 6.57109L4.38413 20.5184C4.4445 21.2058 5.05015 21.7151 5.73765 21.6551L14.8265 20.8592L8.16929 20.2771C6.65629 20.1448 5.53692 18.8107 5.66929 17.2977L6.74449 5.00273L4.30015 5.21758ZM9.73765 2.34551C9.05009 2.28557 8.44429 2.79463 8.38413 3.48222L7.16343 17.4285C7.10326 18.1162 7.61242 18.7228 8.30015 18.783L18.2621 19.6541C18.9496 19.7142 19.5562 19.2059 19.6166 18.5184L20.8363 4.57109C20.8963 3.88344 20.3872 3.27774 19.6996 3.21758L9.73765 2.34551ZM14.4876 7.03008C16.7186 8.34682 18.0976 10.4431 17.9125 11.951C17.7837 12.9975 16.7519 13.7215 15.6048 13.5809C14.9265 13.4975 14.6242 13.1479 14.3031 12.6355C14.3039 13.0789 14.3033 12.636 14.5052 15.0916L12.5199 14.8484C13.3101 12.514 13.201 12.9424 13.3109 12.5135C12.8764 12.9323 12.4982 13.1997 11.8158 13.116C10.6697 12.9752 9.84376 12.0269 9.97202 10.9803C10.1657 9.40289 12.0768 7.7778 14.4876 7.03008Z",
      fill: "white"
    }
  )
);

export { GameBlackjack };
//# sourceMappingURL=GameBlackjack.js.map
